import React, { useState, useEffect } from "react";
import Layout from '../pages/Layout';
import Advertise from "../pages/Advertise";

const StockProfit = () => {
  // State variables for Stock Profit calculation
  const [purchasePrice, setPurchasePrice] = useState(0); // Purchase price per share
  const [sellingPrice, setSellingPrice] = useState(0); // Selling price per share
  const [numberOfShares, setNumberOfShares] = useState(0); // Number of shares
  const [transactionFees, setTransactionFees] = useState(0); // Transaction fees
  const [profit, setProfit] = useState(0); // Calculated profit

  // Event handlers to update state values
  const handlePurchasePriceChange = (e) => setPurchasePrice(parseFloat(e.target.value) || 0);
  const handleSellingPriceChange = (e) => setSellingPrice(parseFloat(e.target.value) || 0);
  const handleNumberOfSharesChange = (e) => setNumberOfShares(parseFloat(e.target.value) || 0);
  const handleTransactionFeesChange = (e) => setTransactionFees(parseFloat(e.target.value) || 0);

  // useEffect hook to calculate profit when any input changes
  useEffect(() => {
    if (purchasePrice && sellingPrice && numberOfShares) {
      const profitAmount = (sellingPrice - purchasePrice) * numberOfShares - transactionFees;
      setProfit(profitAmount);
    } else {
      setProfit(0);
    }

     // This will initialize or reinitialize all popovers on the page whenever the component renders
     const popoverTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="popover"]')
    );

    // Clean up any existing popover instances
    popoverTriggerList.forEach((popoverTriggerEl) => {
      const popover = window.bootstrap.Popover.getInstance(popoverTriggerEl); // Check if instance already exists
      if (popover) {
        popover.dispose(); // Dispose of existing popover
      }
    });

    // Re-initialize popovers
    popoverTriggerList.forEach((popoverTriggerEl) => {
      new window.bootstrap.Popover(popoverTriggerEl); // Re-initialize popovers
    });


  }, [purchasePrice, sellingPrice, numberOfShares, transactionFees]);

  return (
    <Layout title="Stock Profit Calculator" path="stock-profit">
      <section className="section-padding" id="stock-profit-calculator">
        <div className="container mt-5">
          <div className="row">
            {/* Stock Profit Calculator Form */}
            <div className="col-lg-9 col-md-8 mb-4">
              <div
                className="p-4 border rounded shadow"
                style={{ border: "1px solid black" }}
              >
                <h3 className="text-center mb-4">Stock Profit Calculator</h3>
                <div className="container">
                  <div className="row gy-3">
                    {/* Purchase Price Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="purchasePrice" className="form-label">
                        Purchase Price per Share (₹)
                        <span
                    className="ms-2 text-muted"
                    data-bs-toggle="popover"
                    data-bs-html="true"
                    data-bs-placement="top"
                    data-bs-content="<strong>Purchase Price:</strong> The price at which you bought each share of the stock."
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-info-circle"></i>
                  </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="purchasePrice"
                        placeholder="Enter purchase price"
                        value={purchasePrice || ""}
                        onChange={handlePurchasePriceChange}
                      />
                    </div>

                    {/* Selling Price Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="sellingPrice" className="form-label">
                        Selling Price per Share (₹)
                        <span
                    className="ms-2 text-muted"
                    data-bs-toggle="popover"
                    data-bs-html="true"
                    data-bs-placement="top"
                    data-bs-content="<strong>Selling Price:</strong> The price at which you sold each share of the stock."
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-info-circle"></i>
                  </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="sellingPrice"
                        placeholder="Enter selling price"
                        value={sellingPrice || ""}
                        onChange={handleSellingPriceChange}
                      />
                    </div>

                    {/* Number of Shares Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="numberOfShares" className="form-label">
                        Number of Shares
                        <span
                    className="ms-2 text-muted"
                    data-bs-toggle="popover"
                    data-bs-html="true"
                    data-bs-placement="top"
                    data-bs-content="<strong>Number of Shares:</strong> The total number of shares you bought and sold."
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-info-circle"></i>
                  </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="numberOfShares"
                        placeholder="Enter number of shares"
                        value={numberOfShares || ""}
                        onChange={handleNumberOfSharesChange}
                      />
                    </div>

                    {/* Transaction Fees Input */}
                    <div className="col-md-6 col-lg-4">
                      <label htmlFor="transactionFees" className="form-label">
                        Transaction Fees (₹)
                        <span
                    className="ms-2 text-muted"
                    data-bs-toggle="popover"
                    data-bs-html="true"
                    data-bs-placement="top"
                    data-bs-content="<strong>Transaction Fees:</strong> The cost associated with executing the purchase and sale of shares."
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-info-circle"></i>
                  </span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="transactionFees"
                        placeholder="Enter transaction fees"
                        value={transactionFees || ""}
                        onChange={handleTransactionFeesChange}
                      />
                    </div>
                  </div>

                  {/* Result Section */}
                  <div className="mt-4">
                    <div className="p-3 text-center">
                      <h6>
                        Profit or Loss:{" "}
                        <span className="fw-bold ms-3">
                          {profit === 0 ? "₹0.00" : `₹${profit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Advertisement Section */}
            <Advertise />
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="introduction-section" id="introduction">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="p-5">
                <h3 className="text-center mb-5">
                  Introduction to the Stock Profit Calculator
                </h3>

                {/* What is a Stock Profit Calculator? */}
                <h4 className="mt-3 mb-3">What is a Stock Profit Calculator?</h4>
                <p>
                  A **Stock Profit Calculator** helps investors determine the profit or loss made from buying and selling stocks. It factors in the purchase price, selling price, number of shares, and transaction fees to provide the final net result.
                </p>

                {/* Why Use a Stock Profit Calculator? */}
                <h4 className="mt-4 mb-3">Why Use a Stock Profit Calculator?</h4>
                <p>
                  This calculator allows traders and investors to easily calculate their returns on investments. It helps determine if a stock trade was profitable after factoring in transaction costs, making it an essential tool for stock traders and investors.
                </p>

                {/* Benefits of Using a Stock Profit Calculator */}
                <h4 className="mt-4 mb-3">Benefits of Using a Stock Profit Calculator</h4>
                <ul>
                  <li><strong>Helps Investors Track and Analyze Stock Performance:</strong> Enables traders to see their returns from stock trading in real-time.</li>
                  <li><strong>Supports Informed Decision-Making in Trading:</strong> Assists investors in determining whether a stock trade is worth executing based on profit or loss.</li>
                  <li><strong>Useful for Tax Reporting on Capital Gains:</strong> Provides a clear breakdown of profits or losses, which is helpful for filing taxes.</li>
                </ul>

                {/* Suitable For */}
                <h4 className="mt-4 mb-3">Who Should Use a Stock Profit Calculator?</h4>
                <p>
                  This tool is suitable for:
                </p>
                <ul>
                  <li><strong>Individual Investors:</strong> Helps individual traders manage and assess their stock investments.</li>
                  <li><strong>Stock Trading Platforms:</strong> To provide users with a tool for calculating and analyzing their trading performance.</li>
                  <li><strong>Financial Advisors:</strong> Helps advisors track and report the performance of their clients' stock portfolios.</li>
                </ul>

                {/* Additional Questions */}
                <h4 className="mt-4 mb-3">Why should I consider transaction fees?</h4>
                <p>
                  Transaction fees can eat into your profits, so it’s essential to account for them when calculating net gains or losses. Understanding this allows you to make more informed trading decisions.
                </p>

                <h4 className="mt-4 mb-3">How can this tool help with tax reporting?</h4>
                <p>
                  The profit or loss calculated can be reported in your tax filings for capital gains or losses, making tax reporting easier and more accurate.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default StockProfit;
